import day from "./day";
import { logger } from "../logger";

const isExchangeHours = () => {
  const time = day().tz("America/New_York");
  const dayOfWeek = time.day();
  const isWeekDay = dayOfWeek >= 1 && dayOfWeek <= 5;
  if (!isWeekDay) return false;

  const openTime = time.clone().hour(9).minute(30).second(0).millisecond(0);
  const closeTime = time.clone().hour(16).minute(30).second(0).millisecond(0);

  logger.debug("Exchange hours now", time.format());
  logger.debug("Exchange hours open", openTime.format());
  logger.debug("Exchange hours close", closeTime.format());

  return time.isAfter(openTime) && time.isBefore(closeTime);
};

const isExchangeDay = () => {
  const dayOfWeek = day().tz("America/New_York").day();
  return dayOfWeek >= 1 && dayOfWeek <= 5;
};

const marketDay = () => {
  const time = day().tz("America/New_York");
  const currentHour = time.hour();
  if (currentHour >= 0 && currentHour < 7) {
    return time.subtract(1, "day").dayOfYear();
  }
  const dow = time.day(); // 0=Sun, 6=Sat
  if (dow === 6) {
    return time.subtract(1, "day").dayOfYear(); // Saturday -> Friday
  } else if (dow === 0) {
    return time.subtract(2, "day").dayOfYear(); // Sunday -> Friday
  } else {
    return time.dayOfYear();
  }
};

const marketWeek = () => {
  const datetime = day().tz("America/New_York");
  const dow = datetime.day(); // 0=Sun, 1=Mon, ..., 6=Sat
  const marketOpen = datetime.clone().hour(9).minute(30).second(0).millisecond(0);
  logger.debug("Market week day of week", dow);
  if (dow === 0 || (dow === 1 && datetime.isBefore(marketOpen))) {
    // Sunday, or Monday before 9:30 AM ET market open -> previous Monday
    return datetime.subtract(1, "week").day(1).startOf("day");
  }
  return datetime.day(1).startOf("day"); // this Monday
};

const marketYear = () => {
  return day().tz("America/New_York").year();
}

export { isExchangeHours, isExchangeDay, marketDay, marketWeek, marketYear };
